import { Box, Typography } from "@mui/material";
import React from "react";

function Footer() {
  return (
    <>
      <Box
        sx={{
          padding: "10px 15px",
          textAlign: "right",
          borderTop: (theme) => `1px solid ${theme.palette.mode === "dark" ? "#333" : "#e7e7e7"}`,
          backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
        }}
      >
        <Typography
          variant="p"
          sx={{ fontSize: "14px" }}
          color={"primary.safeOnLight"}
          noWrap
          component="div"
        >
          &copy; {new Date().getFullYear()} Schoola | All rights reserved.
        </Typography>
      </Box>
    </>
  );
}

export default Footer;
